import { isClearpay } from "@/utils/locale";

import { Locale } from "@/types/locale";

export const CONSUMER_CONTENT_TYPE_ID = "afterpayConsumerPublicSupportArticle";
export const MERCHANT_CONTENT_TYPE_ID = "afterpayMerchantPublicSupportArticle";

export const CONSUMER_URL_PREFIX = "/help";
export const MERCHANT_URL_PREFIX = "/help-merchant";

const CLEARPAY_CONSUMER_ROOT_TOKEN = "360001635351";
const AFTERPAY_CONSUMER_ROOT_TOKEN = "360001002192";

const CLEARPAY_MERCHANT_ROOT_TOKEN = "1775499875418";
const AFTERPAY_MERCHANT_ROOT_TOKEN = "1775499874416";

export function getConsumerRootToken(locale: Locale): string {
    return isClearpay(locale) ? CLEARPAY_CONSUMER_ROOT_TOKEN : AFTERPAY_CONSUMER_ROOT_TOKEN;
}

export function getMerchantRootToken(locale: Locale): string {
    return isClearpay(locale) ? CLEARPAY_MERCHANT_ROOT_TOKEN : AFTERPAY_MERCHANT_ROOT_TOKEN;
}

export function getHelpArticleUrl(urlPrefix: string, token: string, slug: string): string {
    return `${urlPrefix}/${token}-${slug}`;
}

const CLEARPAY_EXPLORE_MORE_ARTICLE_ID = "1776377727653";
const AFTERPAY_EXPLORE_MORE_ARTICLE_ID = "115000100143";

const AFTERPAY_COMPLAINTS_ARTICLE_ID = "360000839723";
const CLEARPAY_COMPLAINTS_ARTICLE_ID = "900002624606";

// Article tokens that opt out of the "Explore more options" tile: the two
// explore-more landing articles themselves (the tile would self-link) plus the
// complaints articles, which should not surface it.
export const ARTICLES_WITHOUT_EXPLORE_MORE = new Set([
    AFTERPAY_EXPLORE_MORE_ARTICLE_ID,
    CLEARPAY_EXPLORE_MORE_ARTICLE_ID,
    AFTERPAY_COMPLAINTS_ARTICLE_ID,
    CLEARPAY_COMPLAINTS_ARTICLE_ID,
]);

export function getExploreMoreHref(locale: Locale): string {
    const articleId = isClearpay(locale)
        ? CLEARPAY_EXPLORE_MORE_ARTICLE_ID
        : AFTERPAY_EXPLORE_MORE_ARTICLE_ID;
    return `${CONSUMER_URL_PREFIX}/${articleId}`;
}
